import { render, staticRenderFns } from "./CartTripDetails.vue?vue&type=template&id=4a9d20fc&"
import script from "./CartTripDetails.vue?vue&type=script&lang=js&"
export * from "./CartTripDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports